import { Link, useLocation } from 'react-router-dom';
import { Home, MessageCircle, Plus, Search, User, Sparkles } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_ai-persona-connect/artifacts/d3pkba7d_copy_8D43DC47-40F7-432E-B350-F206250169DA.png';

const navItems = [
  { to: '/',           icon: Home,        label: 'Home' },
  { to: '/search',     icon: Search,      label: 'Search' },
  { to: '/chats',      icon: MessageCircle, label: 'Chats' },
  { to: '/profile',    icon: User,        label: 'Profile' },
];

export function DesktopSidebar() {
  const location = useLocation();
  const { user } = useAuth();

  const isActive = (to) => {
    if (to === '/') return location.pathname === '/';
    if (to === '/chats') return location.pathname === '/chats' || location.pathname.startsWith('/chat/');
    return location.pathname === to || location.pathname.startsWith(`${to}/`);
  };

  return (
    <aside
      className="hidden lg:flex fixed left-0 top-0 h-screen w-60 xl:w-64 z-40 border-r border-white/[0.06] bg-[#050505]/95 backdrop-blur-xl flex-col px-5 py-7"
      data-testid="desktop-sidebar"
    >
      {/* Logo */}
      <Link to="/" className="flex items-center gap-2.5 mb-10 group" data-testid="sidebar-logo">
        <img src={LOGO_URL} alt="Animus" className="w-8 h-8 object-contain group-hover:scale-110 transition-transform" />
        <span className="font-bold text-lg tracking-tight text-white font-['Unbounded']">Animus</span>
      </Link>

      {/* Primary nav */}
      <nav className="space-y-1 flex-1">
        {navItems.map(({ to, icon: Icon, label }) => {
          const active = isActive(to);
          return (
            <Link
              key={to}
              to={to}
              className={`group flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all min-h-[44px] ${
                active
                  ? 'bg-gradient-to-r from-[#E11D48]/15 to-transparent text-white border border-[#E11D48]/25'
                  : 'text-[#A1A1AA] hover:text-white hover:bg-white/[0.03] border border-transparent'
              }`}
              data-testid={`sidebar-nav-${label.toLowerCase()}`}
            >
              <Icon className={`w-5 h-5 ${active ? 'text-[#E11D48]' : 'group-hover:text-white'}`} strokeWidth={active ? 2.4 : 1.8} />
              {label}
            </Link>
          );
        })}

      </nav>

      {/* Create CTA — pinned bottom */}
      <Link
        to="/create"
        className="mt-auto inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full bg-gradient-to-r from-[#E11D48] via-[#F472B6] to-[#FECDD3] text-[#2A0314] font-bold text-sm shadow-lg shadow-[#E11D48]/25 hover:scale-[1.02] transition-transform min-h-[44px]"
        data-testid="sidebar-create-cta"
      >
        <Sparkles className="w-4 h-4" />
        Create Character
      </Link>
    </aside>
  );
}
